var _circle, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewest = function SvgNewest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), /*#__PURE__*/React.createElement("foreignObject", {
    width: 62.526,
    height: 62.526,
    x: -17.263,
    y: -17.263
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      clipPath: "url(#newest_svg__a)",
      height: "100%",
      width: "100%"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#newest_svg__b)",
    "data-figma-bg-blur-radius": 17.263
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.5 11v7.731a.5.5 0 0 0 .225.419l.688.456a.5.5 0 0 0 .762-.294L18 16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M18 16a2.5 2.5 0 0 0 0-5h-2.5s-3.406 0-6.681-2.744A.5.5 0 0 0 8 8.638v9.725a.5.5 0 0 0 .819.38C12.094 16 15.5 16 15.5 16z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "newest_svg__b",
    x1: 14,
    x2: 14,
    y1: 0,
    y2: 44.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#070409",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#494949",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "newest_svg__a",
    transform: "translate(17.263 17.263)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14
  })))));
};
export default SvgNewest;